import React, { useEffect, useState } from "react";
import "./showDon.scss";
import { Paper, InputBase, IconButton, Typography } from "@mui/material";
import { BsSearch } from "react-icons/bs";
import * as donService from "../../../services/DonService";
import CardDon from "../../../components/Card/CardDon/CardDon";
import Spinner from "../../../components/Spinner/Spinner";

const ShowDon = () => {
  const [don, setDon] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    donService
      .getAllDon()
      .then((donss) => {
        // Parcourir chaque don dans le tableau
        const resultat = donss.reduce((acc, don) => {
          const donateurId = don?.donateur?.id;

          // Vérifier si le donateur existe déjà dans le tableau
          const donateurExist = acc.find(
            (item) => item.donateur.id === donateurId
          );

          if (donateurExist) {
            // Ajouter le don au tableau existant du donateur
            donateurExist.dons.push(don);
          } else {
            // Créer un nouvel objet donateur avec un tableau de dons
            const nouvelObjetDonateur = {
              donateur: don?.donateur,
              dons: [don],
            };

            // Ajouter le nouvel objet au tableau
            acc.push(nouvelObjetDonateur);
          }

          return acc.filter((d) => d?.donateur?.role !== "admin");
        }, []);

        // Utiliser le résultat comme nécessaire
        setDon(resultat);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des données:", error);
      });
  }, []);

  return (
    <div className="don">
      <div className="search">
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: 400,
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Recherche ..."
            inputProps={{ "aria-label": "search google maps" }}
            onChange={(e) => setSearch(e.target.value.toLocaleLowerCase())}
          />
          <IconButton sx={{ p: "10px" }} aria-label="search">
            <BsSearch />
          </IconButton>
        </Paper>
      </div>

      {isLoading && <Spinner />}
      <div className="content">
        {don.length > 0 ? (
          don
            .filter(
              (user) =>
                user?.donateur?.name.toLocaleLowerCase().includes(search) ||
                user?.donateur?.surname.toLocaleLowerCase().includes(search) ||
                user?.donateur?.fiantso.toLocaleLowerCase().includes(search)
            )
            .map((donation, index) => (
              <CardDon key={index} donation={donation} />
            ))
        ) : (
          <Typography variant="h6">Mbola tsy misy fanohanana</Typography>
        )}
      </div>
    </div>
  );
};

export default ShowDon;
